import React, { useState, useEffect } from 'react';
import { Modal, Progress } from 'antd';
import http from '../../../Http';
import { useTranslation } from 'react-i18next';

const BurningMonitor = ({ visible, type_, burningID, dataLength, onCancel }) => {
    const { t } = useTranslation();
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        let intervalId;

        const fetchProgress = async () => {
            try {
                const resp = await http.postJSON('integrated-inverter-v2/burning-progress/request', {
                    Type: type_,
                    BurnID: burningID,
                }
                ).then(async (r) => {
                    return await r.json();
                }).catch((e) => {
                    console.log("[BurningManagement]", e);
                    return null;
                });
    
                if (resp.code !== 200) {
                    return;
                }
                const currentProgress = resp.data.Progress;
                setProgress((currentProgress / dataLength) * 100);
            } catch (error) {
                console.error(t('Error fetching progress:'), error);
            }
        };

        if (visible) {
            // Initial fetch
            fetchProgress();

            // Set up interval to fetch progress every 3 seconds
            intervalId = setInterval(fetchProgress, 3000);
        }

        // Clean up interval when modal is closed or component unmounts
        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [visible, dataLength, t]);

    return (
        <Modal
            title={t("Burning Progress")}
            visible={visible}
            onCancel={() => onCancel(Math.round(progress))}
            footer={null}
        >
            <Progress percent={Math.round(progress)} status="active" />
        </Modal>
    );
};

export default BurningMonitor;